// extracted by mini-css-extract-plugin
module.exports = {"changePasswordPage":"ChangePasswordPage_changePasswordPage__1ECkA","changePasswordBlock":"ChangePasswordPage_changePasswordBlock__744G8"};